<img
    title="tooltip"
    [matTooltipPosition]="'right'"
    [matTooltip]="message"
    [src]="
        moreInfo
            ? 'assets/svg/flat-info-icon.svg'
            : 'assets/svg/question-tooltip.svg'
    "
    [class]="{ 'h-4': moreInfo, tooltip: true }"
    [alt]="moreInfo ? 'info icon' : 'question mark'"
/>
